<template>
  <div class="box-father">
    <div class="section">
      <div class="mb-15">巡查状态：{{ item.taskStatus }}</div>
      <div class="mb-15">所在社区：{{ item.communityName }}</div>
      <div class="mb-15">联系方式：{{ item.extendBusinessInfo && item.extendBusinessInfo.lxdh }}</div>
      <div class="mb-15">事项目标地址：{{ item.extendBusinessInfo && item.extendBusinessInfo.jzdz }}</div>
      <div class="mb-15">备注：{{ item.extendBusinessInfo && item.extendBusinessInfo.bz }}</div>
      <div class="title mb-15" style="border-bottom: 1px solid #E7E7E7;">巡查情况</div>
      <div class="mb-15">巡查人：{{ item.handlerUsernameStart }}</div>
      <div class="mb-15">巡查时间：{{ item.handlerTimeStart }}</div>
      <div class="mb-15">巡查详情：{{ item.handlerRemarkStart }}</div>
      <div class="mb-15" style="display: flex;">
        <span>现场照片：</span>
        <div style="display: flex; flex: 1; flex-wrap: wrap;">
          <img v-for="(items, indexs) in item.handlerFilejsonStart ? JSON.parse(item.handlerFilejsonStart) : []" :key="indexs" :src="items.url" style="width: 150px;height: 100px;margin: 0 5px 5px 0;">
        </div>
      </div>
      <div class="title mb-15" style="border-bottom: 1px solid #E7E7E7;">历史记录</div>
      <!-- 记录 -->
      <div style="display: flex;position: relative;" v-for="(ritem, rindex) in list" :key="rindex">
        <div style="z-index: 5;"><i class="el-icon-s-order" style="font-size: 20px;color: #fff; background: #1684FC;padding: 10px; border-radius: 50%;"></i></div>
        <div style="flex: 1;margin-left: 20px;">
          <div class="mb-15">{{ ritem.handlerTimeStart }}</div>
          <div class="mb-15">巡查人：{{ ritem.handlerUsernameStart }}</div>
          <div class="mb-15">巡查详情：{{ ritem.handlerRemarkStart }}</div>
          <div class="mb-15" style="display: flex;">
            <span>现场照片：</span>
            <div style="display: flex; flex: 1; flex-wrap: wrap;">
              <img v-for="(items, indexs) in ritem.handlerFilejsonStart ? JSON.parse(ritem.handlerFilejsonStart) : []" :key="indexs" :src="items.url" style="width: 150px;height: 100px;margin: 0 5px 5px 0;">
            </div>
          </div>
        </div>
        <span class="line"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  extendTaskDetail,
  extendTaskPage
} from "@/api/task.js";
export default {
  props: {
    detailId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      item: {},
      list: []
    };
  },
  mounted() {
    this.selListFun();
  },
  methods: {
    async selListFun() {
      const res = await extendTaskDetail({ id: this.detailId });
      if (res.data.code == 200) {
        this.item = res.data.data;
        setTimeout(() => {
          this.extendTaskPage();
        }, 500);
      }
    },
    async extendTaskPage () {
      const res = await extendTaskPage({ 
        extendBusinessId: this.item.extendBusinessId,
        extendFillBussinessInfoFlag: true,
        ghEventTypeId: this.item.ghEventTypeId,
        page: 1,
        size: 100,
        taskStatus: "已完成"
       });
      this.list = res.data.data.records;
    }
  },
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.mb-15 {
  margin-bottom: 15px;
}

.box-father {
  padding: 0 !important;
  padding-bottom: 24px;
  margin-top: 10px;

  .section {
    padding: 12px;

    .right {
      width: 100%;
      height: 100%;
      padding: 28px 24px;
    }

    .title {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 12px;
    }
  }
}

.search-box {
  display: flex;
  margin-bottom: 12px;
}

.type-list {
  height: calc(100% - 94px);
  overflow: auto;

  .type-list-item {
    width: 100%;
    // height: 94px;
    padding: 12px;
    background: #f7faff;
    border-radius: 4px;
    margin-bottom: 12px;
    cursor: pointer;

    .item-top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
        margin: 0 8px 6px 0;
      }

      .type {
        background: rgba(0, 144, 255, 0.1);
        border-radius: 2px;
        padding: 1px 6px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #0090ff;
        margin: 0 0 6px 0;
      }
    }

    .item-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      .edit {
        width: 140px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .type-list-item.active {
    border: 1px solid #3caaff;
    background: #f7faff url("~@/assets/image/active.png") center no-repeat;
    background-size: 100% 100%;
    border-radius: 8px;
  }
}

.line {
  position: absolute;
  left: 20px;
  top: 0;
  height: 100%;
  width: 2px;
  background: rgb(231, 231, 231);
}
</style>



// WEBPACK FOOTER //
// src/pages/noPatrolReport/detail.vue